import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import * as yup from 'yup'

const CreateReferenceModal = ({ isOpen, onClose, onSubmit, data }) => {
  const validationSchema = yup.object().shape({
    description: yup.string().required('აღწერა აუცილებელია'),
    description_ka: yup.string().required('აღწერა ქართულად აუცილებელია'),
    doi_url: yup.string(),
  })

  const initialValues = {
    description: data?.description ?? '',
    description_ka: data?.description_ka ?? '',
    doi_url: data?.doi_url ?? '',
  }

  const labelMapping = {
    description: 'აღწერა (Eng)',
    description_ka: 'აღწერა (ქართულად)',
    doi_url: 'DOI URL',
  }

  const renderInput = (key, formik) => {
    if (key === 'description' || key === 'description_ka') {
      return (
        <Field name={key}>
          {({ field }) => (
            <textarea
              className='border rounded p-2'
              id={key}
              {...field}
              placeholder={labelMapping[key]}
              rows={4}
            />
          )}
        </Field>
      )
    } else {
      return (
        <Field
          className='border rounded py-2'
          autoComplete='off'
          type='text'
          id={key}
          name={key}
          placeholder={labelMapping[key]}
        />
      )
    }
  }

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      centered>
      <Modal.Header closeButton>
        <Modal.Title id='contained-modal-title-vcenter'>რეფერენცის დამატება</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema}>
          {formik => (
            <Form>
              <div className='flex flex-col gap-4 p-3.5'>
                {Object.keys(initialValues).map(key => (
                  <span key={key} className='flex flex-col'>
                    <label htmlFor={key} className='text-lg'>
                      {labelMapping[key]}
                    </label>
                    {renderInput(key, formik)}
                    <ErrorMessage style={{ color: 'red' }} name={key} component='span' />
                  </span>
                ))}
                <div className='flex flex-row items-center gap-3 justify-end w-full'>
                  <Button variant='primary' type='submit'>
                    {data ? 'შენახვა' : 'დამატება'}
                  </Button>
                  <Button onClick={onClose}>Cancel</Button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  )
}

export default CreateReferenceModal
